
export const buildIdFromText = (input: string) => {
  return input
    .trim()
    .replace(/[^\w-\s+]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()
}
